import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  baseApiUrl = environment.baseUrl;
  baseApiKey = environment.apiKey;
  actAPIUrl = environment.ActAPIbaseUrl;
  productLine = environment.productLine;
  accessbaseUrl = environment.AccessbaseUrl;
  accessUrl = environment.AccessUrl;
  webAPIv2Url = environment.WebAPIv2Url;
  ediinkRefUrl = environment.EdiinkRefUrl;
  diinkRefUrl = environment.DiinkRefUrl;
  viewTextRefUrl = environment.ViewTextRefUrl;
protectedRefUrl=environment.ProtectedRefUrl;
  openDetectionUrl = environment.OpenDetectionUrl;
  preSetEncryptPwdKey = environment.PreSetEncryptPwdKey;
  preSetEncryptPwdIVector = environment.PreSetEncryptPwdIVector;
   constructor() { }

}
